import { AttributionBudgetModelDto, StatusDtoEnum } from 'src/graphql/generated-types';
import { getXmlBoolean, getXmlLine } from 'src/app/utils/soap.utils';
import { advancedRuleFPAToXML } from 'src/app/_shared/services/advanced-rule/advanced-rule.xml';
import {
    getAccessibilityRule, getSubventionRule
} from 'src/app/board/activity/activity-shared/activity-generals-settings/activity-activities-settings/classes/activity-activities-settings.xml';
import { arrayNotEmpty } from 'src/app/utils/array.utils';

export function allocationToXML(allocation: AttributionBudgetModelDto): string {
    return `
<AttribBdgModele xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                 xmlns:i="http://www.w3.org/2001/XMLSchema-instance"
                 xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
    ${getXmlLine(allocation, 'Status')}
    ${!!allocation.ArticleModele?.ID
        ? ` <d4p1:ArticleModele>
                ${getXmlLine(allocation.ArticleModele, 'ID')}
            </d4p1:ArticleModele>`
        : ''}
    ${getXmlBoolean(allocation, 'AttribTgExec')}
    ${getXmlLine(allocation, 'Code')}
    ${getXmlLine(allocation, 'DateDernierMAJ')}
    ${getXmlLine(allocation, 'DateEvenement')}
    ${getXmlLine(allocation, 'DateValeurDefaut')}
    ${getXmlLine(allocation, 'Description')}
    ${getXmlLine(allocation, 'Id')}
    ${getXmlLine(allocation, 'IdActivite')}
    ${getXmlLine(allocation, 'IdAnneeRef')}
    ${getXmlLine(allocation, 'IdArticle')}
    ${getXmlLine(allocation, 'IdCompteChargeAbondement')}
    ${getXmlLine(allocation, 'IdComptePMVAbondement')}
    ${getXmlLine(allocation, 'IdDelegation')}
    ${getXmlLine(allocation, 'IdJournalAbondement')}
    ${getXmlLine(allocation, 'IdEnveloppe')}
    ${getXmlLine(allocation, 'IdRglAcc')}
    ${getXmlLine(allocation, 'IdRglSubQta')}
    ${getXmlLine(allocation, 'IsAttribBoule')}
    ${getXmlLine(allocation, 'IsCloture')}
    ${getXmlBoolean(allocation, 'IsMasquee')}
    ${getXmlBoolean(allocation, 'IsNominative')}
    ${getXmlLine(allocation, 'Libelle')}
    ${
        arrayNotEmpty(allocation.ListeClesRepartition?.CleRepartitionModelDTO) ? `
            <d4p1:ListeClesRepartition>
               ${allocation.ListeClesRepartition.CleRepartitionModelDTO
                .map(repartionKey => `
                <d4p1:CleRepartitionModelDTO>
                    <d4p1:Status>${StatusDtoEnum.Inserted}</d4p1:Status>
                    ${getXmlLine(repartionKey, 'IdPlanAnalytique')}
                    ${getXmlLine(repartionKey, 'IdSectionAnalytique')}
                    ${getXmlLine(repartionKey, 'Pourcentage')}
                    <d4p1:SectionAnalytique>
                        <d4p1:Id>${repartionKey.IdSectionAnalytique}</d4p1:Id>
                        <d4p1:Status>${StatusDtoEnum.Inserted}</d4p1:Status>
                        ${getXmlLine(repartionKey, 'IdPlanAnalytique')}
                        ${getXmlLine(repartionKey, 'Pourcentage')}
                    </d4p1:SectionAnalytique>
                </d4p1:CleRepartitionModelDTO>
                `)
                .join('')
                }
            </d4p1:ListeClesRepartition>
        ` : ''
    }
    <d4p1:MoteurRegleAcc>
        ${getXmlLine(allocation.MoteurRegleAcc, 'Status')}
        ${getXmlLine(allocation.MoteurRegleAcc, 'Id')}
        ${getXmlBoolean(allocation.MoteurRegleAcc, 'IsRegleAvancee')}
        ${getXmlLine(allocation.MoteurRegleAcc, 'LibelleRegle')}

        ${getAccessibilityRule(allocation.MoteurRegleAcc.ModeleRegleAcc)}

        ${advancedRuleFPAToXML(allocation.MoteurRegleAcc.RegleAvancee)}
    </d4p1:MoteurRegleAcc>
    <d4p1:MoteurRegleSubQta>
        ${getXmlLine(allocation.MoteurRegleSubQta, 'Status')}
        ${getXmlLine(allocation.MoteurRegleSubQta, 'Id')}
        ${getXmlBoolean(allocation.MoteurRegleSubQta, 'IsRegleAvancee')}
        ${getXmlLine(allocation.MoteurRegleSubQta, 'LibelleRegle')}
        ${getSubventionRule(allocation.MoteurRegleSubQta.ModeleRegleSubQta)}
        ${advancedRuleFPAToXML(allocation.MoteurRegleSubQta.RegleAvancee)}
        ${getXmlLine(allocation.MoteurRegleSubQta, 'TypeRegle')}
    </d4p1:MoteurRegleSubQta>
</AttribBdgModele>
<critere xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
         xmlns:i="http://www.w3.org/2001/XMLSchema-instance"
         xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
    <d4p1:TakeAttBDGForAddOrUpdate>true</d4p1:TakeAttBDGForAddOrUpdate>
</critere>
`;
}
